// @flow
import React from "react";
import { Redirect } from "react-router-dom";

export const RedirectToHome = () => {
	return <Redirect to={"/"} />;
};

export default RedirectToHome;